import { Lock, RotateCcw, Truck } from "lucide-react";
import { useStore } from "../context/StoreContext";

const ICONS = [Truck, RotateCcw, Lock];

const TrustBar = () => {
  const { t } = useStore();
  return (
    <section className="border-y border-[var(--line)] bg-[var(--paper)]" data-testid="trust-bar">
      <div className="mx-auto grid max-w-6xl grid-cols-1 divide-y divide-[var(--line)] px-4 sm:grid-cols-3 sm:divide-x sm:divide-y-0 sm:px-6">
        {t.trust.map((item, i) => {
          const Icon = ICONS[i];
          return (
            <div key={item.title} className="flex items-start gap-3 py-4 sm:px-5 sm:py-5 sm:first:pl-0 sm:last:pr-0" data-testid={`trust-${i}`}>
              <Icon className="accent-text mt-0.5 h-5 w-5 shrink-0" />
              <div>
                <p className="text-sm font-bold">{item.title}</p>
                <p className="text-xs text-[var(--muted)]">{item.desc}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default TrustBar;
